import React from 'react';
import * as XLSX from 'xlsx';
import { BottomNavigationAction } from '@material-ui/core';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

function ExcelExportZimmetIade({ JsonData }) {
  if (JsonData?.length === 0) {
    return (
      <BottomNavigationAction
        disabled={true}
        showLabel
        label={'Excel Al'}
        icon={<CloudDownloadIcon />}
      />
    );
  }

  const handleExport = () => {
    const ExportData = JsonData.map((item) => ({
      MALZEME_STOK_NO: item.MALZEME_STOK_NO,
      MALZEME: item.MALZEME,
      ZIMMET_SURE_GUN: item.ZIMMET_SURE_GUN,
      DEPO_ADET: item.DEPO_ADET,
      ADRES_ADET: item.ADRES_ADET,
      MIKTAR: item.MIKTAR,
      Count: item.Count,
      WarehouseAddressText: item.WarehouseAddressText,
    }));

    // Başlıklar (label) ve veriler (value)
    const headers = [
      { label: 'MalzemeStokNo', value: 'MALZEME_STOK_NO' },
      { label: 'Malzeme', value: 'MALZEME' },
      { label: 'Hareketsiz(Gün)', value: 'ZIMMET_SURE_GUN' },
      { label: 'DepoAdet', value: 'DEPO_ADET' },
      { label: 'AdresAdet', value: 'ADRES_ADET' },
      { label: 'ZimmetAdet', value: 'MIKTAR' },
      { label: 'İadeAdet', value: 'Count' },
      { label: 'Adres', value: 'WarehouseAddressText' },
    ];

    // Başlıkları içeren bir array oluşturuyoruz
    const sheetData = [headers.map(header => header.label), ...ExportData.map(item => headers.map(header => item[header.value]))];

    // Excel dosyasını oluşturma
    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Envanter');

    // Excel dosyasını indirme
    XLSX.writeFile(workbook, 'ZimmetIade.xlsx');
  };

  return (
    <BottomNavigationAction
      onClick={handleExport}
      showLabel
      label={'Excel'}
      icon={<CloudDownloadIcon />}
    />
  );
}

export default ExcelExportZimmetIade;
